import moment from 'moment-timezone';

// The raw table's Start/End cells are written in the export worker and read back on the page. The two
// moments never share a locale, so the cells travel as ISO-8601 with the zone's offset: an instant that
// reads back the same whatever locale either side is in.

// Strict: anything that is not ISO-8601 stays blank instead of being guessed into a shifted time.
const readCell = (value: string): moment.Moment | null => {
  if (!value) {
    return null;
  }
  const date = moment.parseZone(value, moment.ISO_8601, true);
  return date.isValid() ? date : null;
};

/** Writes an instant as a table date cell: ISO-8601 with the offset of `zone` (UTC when there is none). */
export function toCellDate(value: moment.MomentInput, zone?: string): string {
  if (value == null) {
    return '';
  }
  const date = zone ? moment.tz(value, zone) : moment.utc(value);
  return date.isValid() ? date.toISOString(true) : '';
}

/** Reads a table date cell back: its instant, and the offset the date pipe needs to show its wall clock. */
export function parseCellDate(value: string): { date: Date | null; offset: string } {
  const date = readCell(value);
  return date ? { date: date.toDate(), offset: date.format('Z') } : { date: null, offset: '' };
}

/** A table date cell as text in the page's locale, at the cell's own offset. */
export function formatCellDate(value: string): string {
  return readCell(value)?.format('L LTS') ?? '';
}
